import { Box, InputBase, useTheme,IconButton, ButtonBase } from "@mui/material"
import { useEffect, useRef, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import NumberInput from "../../theme/inputs/NumberInput";
import { useTranslation } from "react-i18next";
import { useAddChildProductsMutation } from "../../../newapi/warehouse/productSlice";
import { showToastMessagePostRequest, showToastMessage, showToastMessageRequestError } from "../../../utils/toasts";
import DeleteIcon from '@mui/icons-material/Delete';
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import { yupRequired } from "../../../utils/validation";
import { useCreatePickingJobMutation, useGetFilterCountQuery, useGetOptionsMutation, useGetOptionsQuery } from "../../../newapi/pickingjob/pickingjobSlice";
import Heading from "../../theme/text/Heading";
import ShDropdown, { ShDropdownQuery } from "../../theme/dropdowns/Dropdown";
import cx from 'classnames';
import { MaximizeTwoTone } from "@mui/icons-material";
import ShTextSkeleton from "../../theme/skeleton/ShTextSkeleton";
import { toast } from "react-toastify";
import { useGetWarehousesSelectQuery } from "../../../newapi/warehouse/warehouseApiSlice";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useGetUsersSelectQuery } from "../../../newapi/user/userSlice";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
const MAddExtraSerialNumbers = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const serialNumberRef = useRef();

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const [serialNumbers, setSerialNumbers] = useState([]);

    const [value, setValue] = useState("");

    const handleClose = () => {
        props.handleClose();
        setSerialNumbers([]);
    }
      
    const addSerialNumber = () => {
        if (!value.trim()) return;
        if (serialNumbers.includes(value)) return;

        setSerialNumbers(prev => [...prev, value]);
        setValue("");
    };

    const removeSerialNumber = (sn) => {
        setSerialNumbers(prev => prev.filter(v => v !== sn));
        serialNumberRef?.current.focus();
    };

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
            sx={{
                body:{
                    width:450,
                }
            }}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{props.title ?? t("add_serial_numbers")}</Subheading>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>
            <Box
                sx={{
                    padding: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    pb:0,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                }}
            >
                <Box
                    sx={{
                        height:40,
                        background: colors.grey[100],
                        display:"flex",
                        alignItems:'center',
                        pr:0.5,
                        justifyContent:"space-between",
                        borderRadius:5,

                    }}
                >
                    {/* INPUT */}
                    <InputBase
                        autoFocus
                        inputRef={serialNumberRef}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                            e.preventDefault();
                            addSerialNumber();
                            }
                        }}
                        placeholder={t("enter_serial_number")}
                        sx={{
                            flex:1,
                            paddingX: 2,
                            height:40,
                            lineHeight:"40px",
                            fontSize:14,
                            fontFamily:"Roboto, sans-serif",
                        }}
                    />
                    <ButtonBase
                        onClick={addSerialNumber}
                        sx={{
                            height:32,
                            borderRadius:4,
                            background:theme.palette.mode==="dark" ? colors.txt['secondary'] : colors.grey[400],
                            color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt['light'],
                            px:2,
                            lineHeight:"32px",
                        }}
                    >
                        {t("add")}
                    </ButtonBase>
                </Box>

                {/* SERIAL NUMBER ROWS */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        overflowY: "auto",
                        maxHeight:'300px',
                        pb:1,
                    }}
                >
                    {serialNumbers.map(sn => (
                        <Box
                            key={sn}
                            // onClick={() => removeSerialNumber(sn)}
                            sx={{
                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                borderRadius: 4,
                                height:32,

                                px:1.5,
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:'center',
                                pr:0.5,
                            }}
                        >
                            <Text>{sn}</Text>

                            <ButtonBase
                                onClick={() => removeSerialNumber(sn)}
                                sx={{
                                    background:colors.red[100],
                                    color: colors.red[400],
                                    height:24,
                                    width:24,
                                    borderRadius:4,
                                    lineHeight:"32px",
                                    textAlign:'center',

                                }}
                            >
                                <DeleteOutlineOutlinedIcon/>
                            </ButtonBase>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained" 
                    onClick={() => {
                        // Keep the entered serial numbers when the caller needs a fixed amount and it does not match
                        if (props.expectedAmount !== undefined && serialNumbers.length !== Number(props.expectedAmount)) {
                            toast.error(t("serial_numbers_required"), {
                                position: "bottom-left",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            return;
                        }
                        props.confirm(serialNumbers);
                        setSerialNumbers([]);
                    }}
                    >{t("save")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddExtraSerialNumbers;
